let config = {
    applicationName: 'AI Capacity Quiz', // when modifying, also modify title tag in public/index.html
    baseUrl: 'https://ai-readiness-assessment-server-205041129992.us-east4.run.app',
    // baseUrl: 'http://localhost:8080',
}

export default config;